var CLOSEST_DIV_URL, ClosestDivision;

CLOSEST_DIV_URL = '/layout/get_location_sort?callback=?';

module.exports = ClosestDivision = {
  getClosestDivision: function(options) {
    var error, lang, lat, lng, loc, locale, ref, success;
    if (options == null) {
      options = {};
    }
    loc = options.loc, lat = options.lat, lng = options.lng, success = options.success, error = options.error;
    lang = document.head.getAttribute('data-language');
    locale = document.head.getAttribute('data-locale');
    if ((ref = this._xhr) != null) {
      ref.abort();
    }
    this._xhr = $.getJSON(CLOSEST_DIV_URL, {
      loc: loc,
      lat: lat,
      lng: lng,
      lang: lang,
      locale: locale
    }, success);
    return this._xhr.fail(error);
  },
  abort: function() {
    var ref;
    return (ref = this._xhr) != null ? ref.abort() : void 0;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2NvbW1vbi9tX2Nsb3Nlc3RfZGl2aXNpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2NvbW1vbi9tX2Nsb3Nlc3RfZGl2aXNpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsZUFBQSxHQUFrQjs7QUFHbEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsZUFBQSxHQUNmO0VBQUEsa0JBQUEsRUFBb0IsU0FBQyxPQUFEO0FBQ2xCLFFBQUE7O01BRG1CLFVBQVU7O0lBQzVCLGlCQUFELEVBQU0saUJBQU4sRUFBVyxpQkFBWCxFQUFnQix5QkFBaEIsRUFBeUI7SUFFekIsSUFBQSxHQUFTLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixlQUEzQjtJQUNULE1BQUEsR0FBUyxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsYUFBM0I7O1NBRUosQ0FBRSxLQUFQLENBQUE7O0lBQ0EsSUFBQyxDQUFBLElBQUQsR0FBUSxDQUFDLENBQUMsT0FBRixDQUFVLGVBQVYsRUFBMkI7TUFBQyxLQUFBLEdBQUQ7TUFBTSxLQUFBLEdBQU47TUFBVyxLQUFBLEdBQVg7TUFBZ0IsTUFBQSxJQUFoQjtNQUFzQixRQUFBLE1BQXRCO0tBQTNCLEVBQTBELE9BQTFEO1dBQ1IsSUFBQyxDQUFBLElBQUksQ0FBQyxJQUFOLENBQVcsS0FBWDtFQVJrQixDQUFwQjtFQVVBLEtBQUEsRUFBTyxTQUFBO0FBQ0wsUUFBQTswQ0FBSyxDQUFFLEtBQVAsQ0FBQTtFQURLLENBVlAifQ==
